import type { ProjectModel, ValidationIssue, ValidationResult } from "../domain/types";

function error(path: string, message: string): ValidationIssue {
  return { path, message, severity: "error" };
}

export function validateProject(project: Partial<ProjectModel>): ValidationResult {
  const issues: ValidationIssue[] = [];
  if (project.schemaVersion !== 2) issues.push(error("schemaVersion", "Phiên bản dữ liệu phải là 2."));
  if (!Array.isArray(project.soilLayers) || project.soilLayers.length === 0) {
    issues.push(error("soilLayers", "Phải có ít nhất một lớp đất."));
  } else {
    project.soilLayers.forEach((layer, index) => {
      const prefix = `soilLayers.${index}`;
      if (!Number.isFinite(layer.thickness) || layer.thickness <= 0) issues.push(error(`${prefix}.thickness`, "Chiều dày phải lớn hơn 0."));
      if (!Number.isFinite(layer.gamma) || layer.gamma <= 0) issues.push(error(`${prefix}.gamma`, "Dung trọng phải lớn hơn 0."));
      if (!Number.isFinite(layer.Cv) || layer.Cv <= 0) issues.push(error(`${prefix}.Cv`, "Cv phải lớn hơn 0."));
    });
  }
  const foundation = project.foundation;
  if (!foundation) {
    issues.push(error("foundation", "Thiếu điều kiện nền móng."));
  } else {
    if (foundation.mFactor < 1.1 || foundation.mFactor > 1.7) issues.push(error("foundation.mFactor", "Hệ số m phải trong [1,1; 1,7]."));
    if (!(["single", "double"] as const).includes(foundation.drainage)) issues.push(error("foundation.drainage", "Điều kiện thoát nước không hợp lệ."));
    if (!(["undrained", "drained"] as const).includes(foundation.shearMode)) issues.push(error("foundation.shearMode", "Mô hình sức kháng cắt không hợp lệ."));
  }
  const method = project.treatment?.method;
  if ((method === "pvd" || method === "vacuum_pvd") && project.pvd) {
    if (project.pvd.standard === "tcvn_9355" && (project.pvd.spacing < 1.3 || project.pvd.spacing > 2.2)) {
      issues.push(error("pvd.spacing", "TCVN 9355 yêu cầu khoảng cách PVD trong [1,30; 2,20] m."));
    }
    if (project.pvd.depth <= 0) issues.push(error("pvd.depth", "Chiều sâu PVD phải lớn hơn 0."));
  }
  if (method === "cdm" && project.cdm?.depth !== undefined && project.cdm.depth < 3) {
    issues.push(error("cdm.depth", "TCVN 9403 yêu cầu chiều sâu xử lý tối thiểu 3 m."));
  }
  return { valid: !issues.some((issue) => issue.severity === "error"), issues };
}
